import React from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import { GRADE_BAND_OPTIONS, STEADY_OPTIONS } from './riskFilters';

const TOGGLE_SX = { py: 0.4, px: 1.25, fontSize: '0.72rem', textTransform: 'none' };

const RiskFilterBar = ({
  geographies,
  geoLevel,
  onGeoLevel,
  geoValue,
  onGeoValue,
  geoOptions,
  steadyMode,
  onSteadyMode,
  gradeBand,
  onGradeBand,
  shownCount,
  totalCount,
}) => (
  <Paper
    variant="outlined"
    sx={{ mb: 2, borderRadius: 2, px: 2, py: 1.25, display: 'flex', gap: 1.5, flexWrap: 'wrap', alignItems: 'center' }}
  >
    <FormControl size="small" sx={{ minWidth: 150 }}>
      <InputLabel id="risk-geo-level">Geography</InputLabel>
      <Select
        labelId="risk-geo-level"
        label="Geography"
        value={geoLevel}
        onChange={(event) => onGeoLevel(event.target.value)}
      >
        {geographies.map((level) => (
          <MenuItem key={level.id} value={level.id}>
            {level.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    {geoLevel !== 'state' && (
      <FormControl size="small" sx={{ minWidth: 220 }}>
        <InputLabel id="risk-geo-value">
          {geographies.find((level) => level.id === geoLevel)?.label || 'Area'}
        </InputLabel>
        <Select
          labelId="risk-geo-value"
          label={geographies.find((level) => level.id === geoLevel)?.label || 'Area'}
          value={geoValue}
          onChange={(event) => onGeoValue(event.target.value)}
        >
          <MenuItem value="">
            <em>All</em>
          </MenuItem>
          {geoOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )}
    <ToggleButtonGroup
      exclusive
      size="small"
      value={steadyMode}
      onChange={(_, value) => value && onSteadyMode(value)}
      aria-label="Steady state or phasing"
    >
      {STEADY_OPTIONS.map((option) => (
        <ToggleButton key={option.id} value={option.id} sx={TOGGLE_SX}>
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
    <ToggleButtonGroup
      exclusive
      size="small"
      value={gradeBand}
      onChange={(_, value) => value && onGradeBand(value)}
      aria-label="Grade band"
    >
      {GRADE_BAND_OPTIONS.map((option) => (
        <ToggleButton key={option.id} value={option.id} sx={TOGGLE_SX}>
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
    <Typography variant="caption" color="text.secondary" sx={{ ml: 'auto' }}>
      {shownCount} of {totalCount} charter schools
    </Typography>
  </Paper>
);

export default RiskFilterBar;
